import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Create, Close, Visibility } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { TextField } from '@material-ui/core';
import moment from 'moment';
import { wsFindBy } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '18px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  // { Header: 'Cartera Mesa', accessor: 'base_customer_portfolio_bureau_id', align: 'center' },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'DNI Vendedor', accessor: 'dni' },
  { Header: 'Mesa', accessor: 'base_bureau_description' },
  { Header: 'Cód. cartera', accessor: 'base_customer_portfolio_code' },
  { Header: 'Cartera', accessor: 'base_customer_portfolio_description' },
  { Header: 'Día visita', accessor: 'base_visit_day_description' },
  { Header: 'Ruta', accessor: 'base_route_description' },
  { Header: 'Fec. documento', accessor: 'document_date' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function DailyCustomerPortfolio(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [dailyCustomerPs, setDailyCustomerPs] = useState([]); //constante para el listado
  const [disabledBtn, setDisabledBtn] = useState(false); //constante para el listado
  const [date, setDate] = useState(moment().format('YYYY-MM-DD')); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadDailyCustomerPs() {
    setDataLoading(true);
    setDailyCustomerPs([]);
    let response = await wsFindBy('base/daily-customer-portfolio', { date });
    setDataLoading(false);
    if (response.success) setDailyCustomerPs(response.data);
  }

  async function regenerate() {
    setDataLoading(true);
    setDisabledBtn(true);
    let response = await wsPost('base/daily-customer-portfolio/generate');
    setDataLoading(false);
    if (response.success) {
      setDisabledBtn(false);
      showNotify(response.message);
    } else {
      setDisabledBtn(false);
      showNotify(response.message);
    }
  }

  useEffect(() => {
    loadDailyCustomerPs();
  }, [date]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadDailyCustomerPs} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <div style={{ display: 'flex', justifyContent: 'space-between', color: 'black' }}>
              <div style={{ display: 'flex' }}>
                <span className={classes.cardIconTitle} style={{ marginRight: '15px' }}>
                  Listado Carteras Diarias
                  {dataLoading && <LoadingSpinner />}
                </span>
              </div>
              <Button
                size="sm"
                onClick={() => regenerate()}
                color={props.themeContext.buttonColorWarning}
                disabled={disabledBtn}
              >
                Regenerar
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            <TextField
              label="Fecha"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <ReactTable
              excelName="Carteras-diarias"
              formatDate="DD-MM-YYYY"
              defaultWidth={2000}
              indexRow={[0, 1, 2, 3, 4, 5, 6, 7, 9]}
              widthRow={[180, 350, 150, 200, 150, 200, 200, 350, 5]}
              columns={columns}
              data={dailyCustomerPs.map((dailyCustomerP, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIOS_SHOW}
                      >
                        <Link to={`${dailyCustomerP.id}`}>
                          <Button justIcon round simple color={props.themeContext.buttonColor}>
                            <Visibility />
                          </Button>
                        </Link>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIOS_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(dailyCustomerP)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIOS_DELETED}
                      >
                        <ButtonDelete
                          entity="base/daily-customer-portfolio"
                          id={dailyCustomerP.id}
                          reload={loadDailyCustomerPs}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  // base_customer_portfolio_bureau_id:
                  //   dailyCustomerP.base_customer_portfolio_bureau_id,
                  SlpName: dailyCustomerP.SlpName,
                  dni: dailyCustomerP.dni,
                  base_bureau_description: dailyCustomerP.base_bureau_description,
                  base_customer_portfolio_code: dailyCustomerP.base_customer_portfolio_code,
                  base_customer_portfolio_description:
                    dailyCustomerP.base_customer_portfolio_description,
                  base_visit_day_description: dailyCustomerP.base_visit_day_description,
                  base_route_description: dailyCustomerP.base_route_description,
                  document_date: dailyCustomerP.document_date,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
